import * as React from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "../../redux/actions";
import "../../css/UnitCopyModal.scss";
import { getPrimaryInputs } from "../../api-calls/readApiService";
import { addNotification } from "../../api-utilities/notification-tools";
// expected props
interface IProps {
  updateRedux: any;
  reduxModals: any;
}
// local state
interface IState {
  showUnits:boolean;
  unitQuantity:any;
  unitTag:any;
  unitTagMultiple:string[];
}

class UnitTagEdit extends React.Component<IProps, IState> {
  public state: IState = { unitQuantity:null, unitTag:null, unitTagMultiple:[], showUnits:false};

  //This is a specific modal for copying a unit to the project selected by the user.
  async componentDidMount() {
    const projId = this.props.reduxModals.modalData.projectId.split("-")[1];
    const unitId = this.props.reduxModals.modalData.unitId.split("-")[1];
    const result = await getPrimaryInputs(projId, unitId);

    if (result.hasError){
      const notification = {
        id: "getPrimaryInputsError",
        notificationType: "error",
        title: "Error",
        content: <div className="nf-div">GetPrimaryInputsError {result.errorMessage}</div>
      };
      addNotification(notification);
    }
    if (result.primaryInputs) {
      const unitTagsMultiple = result.primaryInputs?.unitTagMultiple ? result.primaryInputs?.unitTagMultiple.split("|") : [];
      this.setState({
        unitQuantity: result.primaryInputs.unitQuantity,
        unitTag: result.primaryInputs.unitTag,
        unitTagMultiple:unitTagsMultiple
      });
    }
  }
  private handleUnitQuantityChange = (newQty: any) => {
    const value = newQty?.toString() ?? "";

    // ✅ Allow empty input (user is editing/backspacing)
    if (value === "") {
      this.setState({
        unitQuantity: value
      });
      return;
    }
  
    // ❌ Block non-numeric input (but allow typing flow)
    if (!/^\d+$/.test(value)) {
      return;
    }
  
    const parsedQty = Number(value);
  
    this.setState(prevState => {
      const currentTags = prevState.unitTagMultiple || [];
      const baseTag = prevState.unitTag || "";
  
      let updatedTags: string[] = [];
  
      if (parsedQty <= currentTags.length) {
        updatedTags = currentTags.slice(0, parsedQty);
      } else {
        updatedTags = Array.from({ length: parsedQty }, (_, i) => {
          const suffix = String.fromCharCode(65 + i);
          return `${baseTag}${suffix}`;
        });
      }
  
      if (parsedQty === 1) {
        updatedTags = [];
      }
  
      return {
        unitTagMultiple: updatedTags,
        unitQuantity: parsedQty,
        showUnits: parsedQty > 1
      };
    });
    
  };
  private toggleUnits() {
    this.setState({showUnits: !this.state.showUnits});

    //This situation can occur on an existing unit that had a quantity of 2 before the code
    //was added for multiple unit tags.  This allows the user to auto-populate those tags.
    //The usual way this component auto-populates the tags is when the user switches quantities
    //from 1 to 2 or more.
    if (this.state.unitTagMultiple.length === 0 && this.state.unitQuantity > 1){
      const createdTags = Array.from({ length: this.state.unitQuantity }, (_, i) => {
        const suffix = String.fromCharCode(65 + i);
        return `${this.state.unitTag}${suffix}`;
      });
      this.setState({unitTagMultiple: createdTags});
    }
  };
  private handleUnitValueChange (index: number, value: string) {
    const updatedTags = [...this.state.unitTagMultiple];
    updatedTags[index] = value;
  
    this.setState({ unitTagMultiple: updatedTags });
  };
  public render() {
    if (this.state.unitQuantity === null){
        return null;
    }

    return (
      <div className="editUnit">
        <div className="header">Edit Unit Quantity and Tags</div>
        <div className="unitTagContainer">
            <div>
            <div className="config-short-label">Unit Quantity</div>
            <input
                className="unitEditInput"
                type="text"
                value={this.state.unitQuantity}
                onChange={(event) => this.handleUnitQuantityChange(event.currentTarget.value)}
            />
            </div>
            <div className="config-short-label">{Number(this.state.unitQuantity) > 1 ? "Unit Set Tag" : "Unit Tag"}</div>
            <input
                type="text"
                className="unitEditInput"
                value={this.state.unitTag || ""}
                onChange={(event) => this.setState({ unitTag: event.currentTarget.value})}
            />
            {/* Show icon only if quantity > 1 */}
            {this.state.unitQuantity > 1 && (
                <span onClick={(e) => this.toggleUnits()}>
                    <span className = {this.state.showUnits ? "uqty-minus" : "uqty-plus"}></span>
                </span>
            )}

        {/* Render dynamic unit textboxes */}
        
            {this.state.showUnits &&
              
              this.state.unitTagMultiple.map((val:any, index:any) => (
                <div key={index}>
                  <div className="config-short-label">{"Unit Tag " + (index + 1)}</div>
                  <input
                    className="unitEditInput"
                    type="text"
                    placeholder={this.state.unitTag + `${String.fromCharCode(64 + index + 1)}`}
                    value={val}
                    onChange={(e) =>
                      this.handleUnitValueChange(index, e.target.value)
                    }
                  />
                </div>
              ))}
        </div> 

        <div className="button-container">
          <div className={"proj-create-btn" } onClick={() => this.userResponse("ok")}>
            Save
          </div>
          <div className="proj-cancel-btn" onClick={() => this.userResponse("cancel")}>
            Cancel
          </div>
        </div>
      </div>
    );
  }

  private userResponse(response: string) {
    let editUnitQuantityAndTagsResponse = {
      response: response,
      unitQuantity: this.state.unitQuantity,
      unitTag: this.state.unitTag,
      unitTagMultiple: this.state.unitTagMultiple && this.state.unitTagMultiple.length > 0 ? this.state.unitTagMultiple.join("|") : null,
      unitId: this.props.reduxModals.modalData.unitId,
      projectId: this.props.reduxModals.modalData.projectId
    };
    //This will trigger the componentDidUpdate method on ProjectManagement.tsx
    this.props.updateRedux("UPDATE_MODALS", { showModal: false, userResponse: editUnitQuantityAndTagsResponse });
  }
}

//------------------ Redux ----------------------------
function mapStateToProps(state: any) {
  return {
    reduxModals: state.reduxModals
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UnitTagEdit);
